import { AfterViewInit, Component, OnInit } from "@angular/core";
import { RepresentativeDetails } from "src/app/models";
import { environment } from "src/environments/environment";
import { CommonService } from "../services";

declare var $: any;

@Component({
  selector: "cmp-footer",
  standalone: false,
  templateUrl: "./footer.component.html",
})
export class FooterComponent implements OnInit, AfterViewInit {
  public RepresentativeDetails: RepresentativeDetails;
  public crmapiurl: string;
  backgroundSize: string = "contain";
  ngAfterViewInit(): void {
    var INDEX = 0;
    $("#chat-submit").click(function (e) {
      e.preventDefault();
      const msg = $("#chat-input").val();
      if ((msg as string).trim() === "") {
        return false;
      }

      const buttons = [
        { name: "Existing User", value: "existing" },
        { name: "New User", value: "new" },
      ];

      setTimeout(function () {
        // do something
      }, 1000);

      return true;
    });

    $(document).delegate(".chat-btn", "click", function () {
      var value = $(this).attr("chat-value");
      var name = $(this).html();
      $("#chat-input").attr("disabled", false);
    });

    // $("#chat-circle").click(function () {
    //   $("#chat-circle").toggle('scale');
    //   $(".chat-box").toggle('scale');
    // })

    // $(".chat-box-toggle").click(function () {
    //   $("#chat-circle").toggle('scale');
    //   $(".chat-box").toggle('scale');
    // })
  }

  constructor(private commonService: CommonService) {}

  ngOnInit() {
    this.crmapiurl = environment.crmApiUrl;
    this.getCRMRepresentativeDetails();
  }

  closeChatBox(): void {
    $("#chat-circle").toggle("scale");
    $(".chat-box").toggle("scale");
  }

  private getCRMRepresentativeDetails(): void {
    this.commonService.GetCRMRepresentativeDetails().subscribe((resp) => {
      if (!resp.error) {
        this.RepresentativeDetails = resp.data;
        if (this.RepresentativeDetails.ProfilePic) {
          this.RepresentativeDetails.ProfilePic = encodeURI(
            this.crmapiurl + this.RepresentativeDetails.ProfilePic
          );
        } else {
          this.backgroundSize = "40px";
          this.RepresentativeDetails.ProfilePic =
            "assets/img/customer-service.svg";
        }
      }
    });
  }
}
